import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';

let redirectionPath;

const path = window.location.pathname;
if (path.startsWith('/admin')) {
  if (path !== '/admin') {
    redirectionPath = '/admin';
  }
} else if (!path.startsWith('/auth')) {
  redirectionPath = '/auth';
}

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      ((localStorage.getItem('token_admin') || localStorage.getItem('token_producer')) ? <Component {...props} /> : <Redirect to={redirectionPath} />)
    }
  />
);

PrivateRoute.propTypes = {
  component: PropTypes.oneOfType([PropTypes.func, PropTypes.node]).isRequired,
};

export default PrivateRoute;



// WEBPACK FOOTER //
// ./src/components/PrivateRoute/index.js